import { useEffect, useState } from 'react';
import { apiClient } from '../../services/http.js';

export function InvoiceHistory() {
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const { res, data } = await apiClient.request('/billing/invoices');
                if (!res.ok) throw new Error('invoices_failed');
                setInvoices(data?.invoices || []);
            } catch {
                setInvoices([]);
            }
        };

        fetchInvoices();
    }, []);

    return (
        <div className="bg-surface-container-low rounded-lg border border-outline-variant overflow-hidden">
            <table className="w-full">
                <thead className="border-b border-outline-variant">
                    <tr className="bg-surface-container-lowest">
                        <th className="px-6 py-3 text-left text-sm font-semibold">Fatura</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold">Data</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold">Valor</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold">Status</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices.map((invoice) => (
                        <tr key={invoice.id} className="border-b border-outline-variant hover:bg-surface-container-lowest">
                            <td className="px-6 py-3">#{invoice.number}</td>
                            <td className="px-6 py-3 text-on-surface-variant">{new Date(invoice.date).toLocaleDateString('pt-BR')}</td>
                            <td className="px-6 py-3 font-semibold">R$ {(invoice.amount / 100).toFixed(2)}</td>
                            <td className="px-6 py-3">{invoice.status === 'paid' ? 'Pago' : 'Pendente'}</td>
                            <td className="px-6 py-3">{invoice.pdf_url ? <a href={invoice.pdf_url} target="_blank" rel="noreferrer" className="text-primary hover:underline">Baixar</a> : '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
